export type NumberDraftResult =
  | { ok: true; value: number }
  | { ok: false; error: string };

export const parseNumberDraft = (
  draft: string,
  bounds: {
    min: number;
    max: number;
    integer: boolean;
  },
): NumberDraftResult => {
  if (draft.trim() === "") {
    return { ok: false, error: "Value is required" };
  }
  const value = Number(draft);
  if (!Number.isFinite(value)) {
    return { ok: false, error: "Enter a number" };
  }
  if (bounds.integer && !Number.isInteger(value)) {
    return { ok: false, error: "Whole numbers only" };
  }
  if (value < bounds.min || value > bounds.max) {
    return {
      ok: false,
      error: `Must be between ${bounds.min} and ${bounds.max}`,
    };
  }
  return { ok: true, value };
};
